// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-descriptions-item-label {\n  min-width: 280px;\n  width: 280px;\n}", ""]);
// Exports
module.exports = exports;
